import { useContext, useMemo } from "react"
import { useNavigate } from "react-router-dom";
import '../style/components/productTable.css';
import { deleteItem, update } from "./indexDB/indexDBStora";
import { dataa } from "../context/data";
import { switchh } from "../context/switch";
import { MakeAsync } from "../funcs/MakeAsync";
import { useTranslation } from "react-i18next";
import { auth } from "../context/auth";

export default function ProductTable() {
    const { t } = useTranslation();
    const { products } = useContext(dataa);
    const { user } = useContext(auth);
    const { setLoadingProcess } = useContext(switchh);
    const { category } = useContext(dataa);
    const navigate = useNavigate();

    const deleteProduct = async (item) => {
        try {
            setLoadingProcess(true);
            if (!item) return;
            
            const updatedItem = MakeAsync(item, "delete");
            if (updatedItem === null) {
                const key = item?.id;
                if (!key) {
                    throw new Error("Barcode not found");
                }
                await deleteItem("products", key);
            } else {
                await update("products", updatedItem);
            }
        } 
        catch (error) {
            console.error("Error deleting product:", error);
        }
        finally {
            setLoadingProcess(false);
        }
    };

    const categoryMap = useMemo(() => {
    return Object.fromEntries(
        category.map((cat) => [cat.id, cat.name])
    );
    }, [category]);
    const currency = user?.data[0]?.currency.code;
    return (
    <table className="table-page">
            <thead>
                <tr>
                    <th></th>
                    <th>{t("label:product.barcode")}</th>
                    <th>{t("label:product.productName")}</th>
                    <th>{t("label:product.pricing")}</th>
                    <th>{t("label:product.discount.label")}</th>
                    <th>{t("label:product.category.label")}</th>
                    <th>{t("common:createdAt")}</th>
                    <th>SKU</th>
                    <th>{t("common:sync")}</th>
                    <th>{t("common:action")}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
        {products.map((e) => {
            const isActive = e?.isPublish && e?.async?.status === "t";

            return (
            <tr key={e.id}>
                <td>{isActive ? "🟢" : "🔴"}</td>

                <td>{e.meta?.barcode}</td>

                <td>{e.nameProudct}</td>
                
                <td>{e.sellPrice} {currency}</td>

                <td>{
                e.discount.discountValue > 0 ?
                `${e.discount.discountValue} ${e.discount.discountType !== "fixed" ? "%" : currency}`
                :
                "not found"
                }</td>

                <td>
                {categoryMap[e.categoryId] || t("common:notFound")}
                </td>

                <td>{e.meta?.createdAt}</td>

                <td>{e.sku}</td>

                <td className={e?.async?.status === "t" ? "success" : "error"}>
                {e?.async?.status === "t" ? "T" : "N"}
                </td>

                <td className="option flex">
                <button onClick={() => navigate(`edit/${e.id}`)} className="success-bg">
                    {t("action:edit")}
                </button>

                <button onClick={() => deleteProduct(e)} className="error-bg">
                    {t("action:delete")}
                </button>

                <button onClick={() => navigate(`scan/${e.meta?.barcode}`)} className="normal-bg">
                    {t("action:mirror")}
                </button>

                <button className="warning-bg">
                    {t("action:subended")}
                </button>
                </td>
            </tr>
            );
        })}
    </tbody>
    </table>
    )
}